import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { PurchasingService } from '../../../services/purchasing.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { PrintService } from '../../../services/print.service';

@Component({
	selector: 'app-vendordash-outstanding-grns',
	templateUrl: './vendordash-outstanding-grns.component.html',
	styleUrls: ['./vendordash-outstanding-grns.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotate3d(0, 1, 0, 179deg)',
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			transition('active => inactive', animate('500ms ease-out')),
			transition('inactive => active', animate('500ms ease-in')),
		]),
	]
})
export class VendordashOutstandingGrnsComponent implements OnInit {
	flip = 'inactive';
	@Output() viewData = new EventEmitter<any>();
	viewing: any = false;

	data: any = false;
	title = 'Outstanding GRNs';
	@ViewChild('print_table') printtable: ElementRef;

	constructor(private printService: PrintService, private globalSearchService: GlobalSearchService, private purchasingService: PurchasingService) {}

	ngOnInit(): void {
		this.purchasingService.getOpenGrns().subscribe(async (results: any) => {
			this.data = results;
		});
	}

	toggleFlip(data: any, title: string) {
		if (!data) {
			this.flip = 'inactive';
		} else {
			this.flip = (this.flip == 'active') ? 'inactive' : 'active';
		}

		if (this.flip == 'active') {
			this.viewing = data;
			this.title = title;
			const dashboard_data = { data: data, title: this.title };
			this.viewData.emit(dashboard_data);
		} else {
			this.viewing = false;
			this.viewData.emit(false);
		}
	}

	exportPdf() {
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const data = {
			content: encoded,
			filename: this.title,
		};

		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
		});
	}

	exportXls() {
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const data = {
			content: encoded,
			filename: this.title,
		};

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
		});
	}
}









